import { render, staticRenderFns } from "./TableParent.vue?vue&type=template&id=1426959f"
import script from "./TableParent.vue?vue&type=script&lang=js"
export * from "./TableParent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports